import {ScrollView, View} from "react-native";
import {useContext} from "react";
import AppConfigContext from "../../../contexts/AppConfigContext";
import {Colors} from "../colors";
import PropTypes from "prop-types";
import {useFocusEffect} from "@react-navigation/native";

function HeaderPage(props: any) {
    const configContext = useContext(AppConfigContext);
    const texts = configContext.texts;
    const colors = Colors.instance(configContext.theme, useContext(AppConfigContext).color);

    useFocusEffect(() => {
        configContext.setPageTitle(props.title);
        configContext.setIfPageHasHeader(true);
    });

    return props.scrollableContent ?
        <ScrollView style={{flex: 1}}>
            {props.children}
        </ScrollView> :
        <View  style={{flexGrow: 1}}>
            {props.children}
        </View>
}

HeaderPage.propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.any.isRequired,
    scrollableContent: PropTypes.bool
}

export default HeaderPage;